const SIDEBAR_STORAGE_KEY = 'app/sidebar'

export default{
  SIDEBAR_STORAGE_KEY
}
